import { render, staticRenderFns } from "./GenericTableExpandable.vue?vue&type=template&id=0ef856da&"
import script from "./GenericTableExpandable.vue?vue&type=script&lang=js&"
export * from "./GenericTableExpandable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports